import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractService } from '../commons/abstract.service';
import { AttendanceWhisper, AttendanceWhisperCreate } from '../models/attendance-whisper.model';

@Injectable({ providedIn: 'root' })
export class AttendanceWhisperService extends AbstractService<AttendanceWhisper> {

  getURLBase(): string {
    return '/attendance-whisper';
  }

  constructor(private http: HttpClient) {
    super(http);
  }

  preCreate(obj: AttendanceWhisper): void {
    delete obj?._id;
  }

  preUpdate(obj: AttendanceWhisper): void {
  }

  getByAttendance(idAttendance: string): Observable<Array<AttendanceWhisper>> {
    return super.get(`/attendance/${idAttendance}`);
  }

  send(body: AttendanceWhisperCreate): Observable<AttendanceWhisper> {
    return super.post('/create', body);
  }

  getPending(): Observable<Array<string>> {
    return super.get('/pending');
  }

  markSeen(idAttendance: string): Observable<void> {
    return super.put(`/seen/${idAttendance}`, {});
  }

}
